import { useState, useEffect } from 'react';

/**
 * Hook to manage welcome carousel visibility
 * Shows carousel to all users (new and existing) 1-2 times
 * Uses version tracking to handle future carousel updates
 */
export function useWelcomeCarousel() {
  const [isOpen, setIsOpen] = useState(false);
  
  useEffect(() => {
    // Check if user has explicitly opted out
    const hasOptedOut = localStorage.getItem('welcomeCarouselShown') === 'true';
    
    if (hasOptedOut) {
      return;
    }
    
    // Use a version-specific key for this carousel
    const carouselVersion = "v1"; // Increment this when carousel content changes
    const carouselKey = `welcomeCarousel_${carouselVersion}_views`;
    
    // Get view count for this specific carousel version
    const viewCount = parseInt(localStorage.getItem(carouselKey) || '0');
    
    // Set a session flag to prevent showing on navigation
    const sessionKey = `welcomeCarousel_${carouselVersion}_shownThisSession`;
    const shownThisSession = sessionStorage.getItem(sessionKey) === 'true';
    
    // Show carousel if it hasn't been shown enough times yet and not already shown this session
    if (viewCount < 2 && !shownThisSession) {
      // Small delay to ensure app is fully loaded first
      const timer = setTimeout(() => {
        setIsOpen(true);
        // Mark as shown this session
        sessionStorage.setItem(sessionKey, 'true');
        // Increment view count
        localStorage.setItem(carouselKey, (viewCount + 1).toString());
      }, 800);
      
      return () => clearTimeout(timer);
    }
  }, []);
  
  return {
    isCarouselOpen: isOpen,
    setCarouselOpen: setIsOpen
  };
}
